import React from 'react'

const Save = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.75 17.4307V12.0227C22.75 7.37517 22.75 5.05359 21.3222 3.6095C19.8943 2.1665 17.5955 2.1665 13 2.1665C8.4045 2.1665 6.10567 2.1665 4.67783 3.6095C3.25 5.0525 3.25 7.37734 3.25 12.0227V17.4318C3.25 20.7858 3.25 22.4638 4.04517 23.1962C4.42433 23.5461 4.90317 23.766 5.41342 23.8245C6.48267 23.9469 7.73175 22.8419 10.2288 20.633C11.3338 19.6569 11.8853 19.1683 12.5233 19.0405C12.8375 18.9755 13.1625 18.9755 13.4767 19.0405C14.1158 19.1683 14.6672 19.6569 15.7712 20.633C18.2683 22.8419 19.5173 23.9469 20.5866 23.8234C21.0958 23.766 21.5757 23.5461 21.9548 23.1962C22.75 22.4638 22.75 20.7858 22.75 17.4307Z" fill="currentColor" stroke="black" strokeWidth="2" />
            <path d="M16.25 6.5H9.75" opacity="0.5" stroke="black" strokeLinecap="round" strokeWidth="1.08333"></path>
        </svg>
    )
}

export default Save
